import { FormControlLabel, Switch } from "@mui/material";

import { AccountStrategy } from "features/trading/accounts";
import { useManualModeToggle } from "hooks/useManualModeToggle";

interface ManualModeSwitchProps {
  accountStrategy: AccountStrategy | undefined;
  canCreate: boolean;
}

export const ManualModeSwitch = ({
  accountStrategy,
  canCreate,
}: ManualModeSwitchProps) => {
  const { toggle, isToggling } = useManualModeToggle(accountStrategy);

  return (
    <FormControlLabel
      sx={{ m: 0 }}
      control={
        <Switch
          checked={accountStrategy?.manually_managed ?? false}
          onChange={toggle}
          disabled={!canCreate || !accountStrategy || isToggling}
        />
      }
      label="Manual mode"
    />
  );
};
